export const REGIONS = [
    { header: "Europe", value: "EU" },
    { header: "America", value: "AMER" },
    { header: "AsiaPacific", value: "APAC" },
  ];